module.exports = __webpack_public_path__ + "static/media/waterfront.2d805247.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/waterfront.jpg
// module id = 623
// module chunks = 0